import {getCurrentYear} from '../../utils/commons'
import SportsGearBestPicksLogo from './logo'
import {sportsGearBestPicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'sportsgearbestpicks' as const,
  domainType: 'picks' as const,
  siteName: 'Sports Gear Best Picks',
  logo: <SportsGearBestPicksLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/sportsgearbestpicks.png',
  styles: sportsGearBestPicksStylesUS,
}

const localeConfigs = {
  us: {
    measurementId: 'G-0DN5GKRNRG',
    camelCaseUrl: 'SportsGearBestPicks.com',
    title: (category: string, count: string) =>
      `Top ${count} ${category} ${getCurrentYear()} in the US | SportsGearBestPicks.com – Pro Reviews & Buying Guides`,
    description: (_category?: string, count?: string) =>
      `Discover the top sports gear with SportsGearBestPicks.com. Our expert team curates comprehensive top ${count} lists with in-depth reviews`,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
